import { useCallback, useEffect, useState } from "react";
import {
  partnersList,
  partnerCreate,
  partnerUpdate,
  partnerDelete,
} from "../../../../api/auth";

export function useDeliveryPartners() {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);
  const [partners, setPartners] = useState([]);

  const refresh = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await partnersList();
      const data = res.data;
      setPartners(data.results ?? data ?? []);
    } catch (e) {
      setError(e);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const createPartner = useCallback(
    async (payload) => {
      setSaving(true);
      setError(null);
      try {
        await partnerCreate(payload);
        await refresh();
      } catch (e) {
        setError(e);
      } finally {
        setSaving(false);
      }
    },
    [refresh]
  );

  const updatePartner = useCallback(
    async (id, payload) => {
      setSaving(true);
      setError(null);
      try {
        await partnerUpdate(id, payload);
        await refresh();
      } catch (e) {
        setError(e);
      } finally {
        setSaving(false);
      }
    },
    [refresh]
  );

  const deletePartner = useCallback(
    async (id) => {
      setSaving(true);
      setError(null);
      try {
        await partnerDelete(id);
        await refresh();
      } catch (e) {
        setError(e);
      } finally {
        setSaving(false);
      }
    },
    [refresh]
  );

  return {
    partners,
    loading,
    saving,
    error,
    refresh,
    createPartner,
    updatePartner,
    deletePartner,
  };
}